import { Component, EventEmitter, OnDestroy, OnInit, Output } from '@angular/core';
import { GenericStateService } from '../../services/generic-state/generic-state.service';
import { SpaceTypeStoreService } from '../../services/store/spacetype-store/spacetype-store.service';
import { FundingsourcestoreService } from '../../services/store/fundingsource-store/fundingsource-store.service';
import { TripStoreService } from '../../services/store/trip-store/trip-store.service';
import { DriversStoreService } from '../../services/store/drivers-store/drivers-store.service';
import * as _ from 'underscore';
import * as moment from 'moment';
import { CdkDragDrop, moveItemInArray, transferArrayItem } from '@angular/cdk/drag-drop';
import { SharedDataService } from 'src/app/service/shared-service/shared-data.service';
import { componentDestroyed } from '@w11k/ngx-componentdestroyed';
import { takeUntil } from 'rxjs/operators';
import { ServiceareaStoreService } from '../../services/store/servicearea-store/servicearea-store.service';
import { LosStoreService } from '../../services/store/los-store/los-store.service';
import { FleetStoreService } from '../../services/store/fleet-store/fleet-store.service';
import { DetailStoreService } from '../../services/store/detail-store/detail-store.service';
import { sweetAlert } from 'src/app/utils/swal';
import { AssigTripsService } from 'src/app/component/assigned-trips/assigntrips-service/assigntrips-service';
import { SearchStoreService } from '../../services/store/search-store/search-store.service';


@Component({
  selector: 'app-route-all',
  templateUrl: './route-all.component.html',
  styleUrls: ['./route-all.component.css']
})
export class RouteAllComponent implements OnInit, OnDestroy {
  @Output() updatedTrip = new EventEmitter<any>();
  trips = [];
  driverList = []
  preDriverList:any = {};
  preFleetList:any = {};
  serviceAreaList = []
  corporateList = []
  levelOfServiceList = []
  fleetList = []
  spaceTypeList = []
  driverTrips;
  user;
  timeZone;
  todayDate;
  timeRange;
  selectedTrip:any;
  selectedDriver: any;
  currentDate = [moment(),moment()];

  constructor(
    private tripStore: TripStoreService,
    private driverStore: DriversStoreService,
    private sharedDataService: SharedDataService,
    private fundingSourceStore: FundingsourcestoreService,
    private spaceTypeStore: SpaceTypeStoreService,
    private serviceAreasStore: ServiceareaStoreService,
    private losStore: LosStoreService,
    private fleetStore: FleetStoreService,
    private detailStore: DetailStoreService,
    private assignTripService: AssigTripsService,
    private searchStore: SearchStoreService
  ) { }


  ngOnInit() {
    this.getUser()
  }


  getUser() {
    this.sharedDataService
      .getUser()
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(user => {
        if (user) {
          this.user = user
          this.timeZone = user.company ? user.company.timeZone : user.timeZone;;
          this.todayDate = moment.tz(this.timeZone).startOf("day").toISOString(),
          this.timeRange = [moment(this.todayDate).tz(this.timeZone).startOf("day").toISOString(), moment(this.todayDate).tz(this.timeZone).endOf("day").toISOString()]

         this.prepare();
        }
      });
  }

  prepare() {
    this.detailStore.setEntities([]);

    this.searchStore.state$.subscribe((res: any) => {
      if (res) {
           this.currentDate = res.date;
      }
    })

    this.driverStore.state$.subscribe((data) => {
      if (data) {
        this.driverList = data.list;
        this.preDriverList = data.map;
      }
    })

    this.serviceAreasStore.state$.subscribe((data) => {
      if (data) {
        this.serviceAreaList = data.list;
      }
    })
    this.fundingSourceStore.state$.subscribe((data) => {
      if (data) {
        this.corporateList = data.list;
      }
    })
    this.losStore.state$.subscribe((data) => {
      if (data) {
        this.levelOfServiceList = data.list;
      }
    })

    this.fleetStore.state$.subscribe((data) => {
      if (data) {
        this.fleetList = data.list;
        this.preFleetList = data.map;
      }
    })
    this.spaceTypeStore.state$.subscribe((data) => {
      if (data) {
        this.spaceTypeList = data.list;
      }
    })

    this.tripStore.state$.subscribe((data) => {
      if (data) {
        this.trips = data.list;
        const willCallTime = moment().tz(this.timeZone).hour(22).minute(0).second(0).millisecond(0);

        const groupedTrips = _.groupBy(
          this.trips,
          trip => {
            const orignalTime = moment(trip.scheduleTime).tz(this.timeZone);
            if (moment(orignalTime.format('HH:mm:ss'), 'HH:mm:ss').tz(this.timeZone).isSameOrAfter(willCallTime)) {
              return 'will_call';
            }
            else

              if (trip.driver) {
                return trip.driver._id;
              }
              else {
                return 'no_driver';
              }
          }
        );

        const dTrips = {};

        this.driverList.forEach(driver => {
          const trips = groupedTrips[driver._id]
          if (trips && trips.length) {
            dTrips[driver._id] = trips;
          }
        });

        this.driverTrips = dTrips;
        if (groupedTrips['no_driver']) {
          this.driverTrips['no_driver'] = groupedTrips['no_driver'];
        }

        if (groupedTrips['will_call']) {
          this.driverTrips['will_call'] = groupedTrips['will_call'];
        }

        this.driverTrips = this.reorderKeys(dTrips);
      }
    })
  }


  getStartPoint(date, b) {
    let startinghoursPoint = moment(date).tz(this.timeZone).hours() * 12;

    if (startinghoursPoint < 1) {
      startinghoursPoint = 1
    }

    if (b && startinghoursPoint < 1) {
      startinghoursPoint = 1;
    }

    const startingMinutesPoint = this.calculateMinutesValue(moment(date).tz(this.timeZone).minutes());
    return startinghoursPoint + startingMinutesPoint;

  }

  getEndPoint(dateOne, dateTwo) {
    const time1 = this.getStartPoint(dateOne, true);
    const time2 = this.getStartPoint(dateTwo, true);
    const difference = time2 - time1;
    return time1 + difference;
  }

  getNumberOfDrivers() {
    return Object.keys(this.driverTrips).length;
  }


  calculateMinutesValue(value) {
    return Math.round(((value * 12) / 60));
  }

  filterDetails(trip){
    if(trip){
      this.detailStore.setEntitiesNew(trip);
    }
  }


  shiftTime(item, trips) {

    if (item &&
      this.preDriverList &&
      this.preDriverList[item.key] &&
      this.preDriverList[item.key].shifts &&
      this.preDriverList[item.key].shifts.length
    ) {
      const time = trips && trips.length ? trips[0].scheduleTime : this.todayDate;
      const shift = this.currentDayShift(time, this.preDriverList[item.key].shifts);

      const start = this.getGradientStyle(shift.checkin);
      const end = this.getGradientStyle(shift.checkout);
      return {'background-image': `linear-gradient(90deg, #ddd ${(start).toFixed(2)}%, #cbffd2 ${(start + 2).toFixed(2)}%, #cbffd2 ${(end).toFixed(2)}%, #ddd ${(end + 2).toFixed(2)}%)`}
    } else {
      return '';
    }


  }

  getGradientStyle(time): any {
    const hourSlot = parseFloat(time.replace(":", "."));
    return (hourSlot / 24) * 100;
  }

  clockTime() {
    return this.getGradientStyle(moment().tz(this.timeZone).format('HH:mm')).toFixed(2)+'%';
  }

  currentDayShift(time, shifts) {
      const currentDay = moment(time).tz(this.timeZone).day();
      if (shifts) {
        let shift = shifts.find(shift => shift.day === currentDay);
        return shift;
      } else {
        return {};
      }
  }

  shiftStartAt(item) {
    if (this.preDriverList && this.preDriverList[item.key] && this.preDriverList[item.key].shifts) {
      const shift = this.currentDayShift(this.currentDate[0], this.preDriverList[item.key].shifts);
      if (shift) {
        const startPoint = this.getStartPoint(moment(shift.checkin, "HH:mm"), true);
        return { 'grid-column': startPoint + ' / ' + (startPoint + 6) };

      }
    }

    return { 'display': 'none' }

  }

  shiftEndAt(item) {
    if (this.preDriverList && this.preDriverList[item.key] && this.preDriverList[item.key].shifts) {
      const shift = this.currentDayShift(this.currentDate[0], this.preDriverList[item.key].shifts);
      if (shift) {
        const startPoint = this.getStartPoint(moment(shift.checkout, "HH:mm"), true);
        return { 'grid-column': startPoint + ' / ' + (startPoint + 7) };
      }
    }
    return { 'display': 'none' }
  }

  sortMethod() {
    return 0;
  }

  getConnectedZoneIds(currentZoneId: string): string[] {
      const filtered = Object.keys(this.driverTrips).filter(key => key !== currentZoneId)
      return filtered;
    }

    onDrop(event: CdkDragDrop<string[]>, zoneId: string) {
      console.log(`Item dropped into ${zoneId}`);
      const from = event.previousContainer;
      const to = event.container;
      const targetDriver = this.preDriverList[zoneId];
      const alertMessage = this.getAlertMessage(zoneId, targetDriver);
      const trip: any = from.data[event.previousIndex];
      if (trip && trip.farmout) return;
      if (event.previousContainer.id === event.container.id) return;
      if (to.id === "will_call") return;
      if (from.id === "will_call" && to.id === "no_driver") return;

      sweetAlert('Alert', alertMessage, 'warning', 'Yes', 'No')
        .then((result: any) => {
          if (result.value){
            if (event.previousContainer === event.container) {
              moveItemInArray(to.data, event.previousIndex, event.currentIndex);
            } else {
              transferArrayItem(from.data, to.data, event.previousIndex, event.currentIndex);
            }
            if (zoneId === 'no_driver') {
              this.selectedTrip = trip;
              this.unAssignTrip();
            } else {
              this.selectedTrip = trip;
              this.selectedDriver = targetDriver;
              this.assignTrip();
            }
          }

        })

    }

  eventColors(item, trip) {
  const isPreDriver = this.preDriverList[item.key];
  let combinedClass = '';

  switch (true) {
    // case !isPreDriver:
    //   combinedClass = 'text-[#bbbbbb] bg-[#3366DD]';
    //   break;

    case item.key === "will_call":
      combinedClass = 'text-[#BBBBBB] bg-[#876AF1]';
    break;

    case trip.jobStatus === 'started':
      combinedClass = 'text-[#777777] bg-[#74E6E8]';
      break;

    case trip.jobStatus === 'offered' || trip.status === 'accepted':
      combinedClass = 'text-[#777777] bg-[#DDBB7D]';
      break;

    case trip.jobStatus === 'finished':
      combinedClass = 'text-[#1A1A1E] bg-[#95DD7A]';
      break;

    case trip.jobStatus === 'cancelled':
      combinedClass = 'text-[#1A1A1E] bg-[#E77474]';
      break;

    default:
      combinedClass = 'text-[#777777] bg-[#DDBB7D]';
      break;
  }

  return combinedClass;
}

  isDisabledDrag(trip) {
    return !['offered', 'accepted', 'unassigned'].includes(trip.status) || !!trip.farmout;
  }



    assignTrip() {
      this.selectedTrip.driver = this.selectedDriver._id;
      this.selectedTrip.status = 'offered';
      this.selectedTrip.jobStatus = 'offered';
      this.assignSingleTrip(this.selectedTrip);
    }

    assignSingleTrip(payload) {

      this.assignTripService
        .assignTrip(payload)
        .pipe(takeUntil(componentDestroyed(this)))
        .subscribe(data => {
          if (data) {
            this.selectedTrip = null;
            data.driver = this.preDriverList[data.driver];
            this.updatedTrip.emit(data);
          }
        }, err => {
          sweetAlert('Error', err, 'warning', 'OK');
        });
    }


    getAlertMessage(zoneId: string, targetDriver: any): string {
      return zoneId === 'no_driver'
        ? 'Are you sure you want to unassign this trip?'
        : `Are you sure you want to assign this trip to ${ targetDriver.displayName }?`;
    }

    unAssignTrip() {
        this.selectedTrip.jobStatus = 'pending';
        this.selectedTrip.status = 'unassigned';
        this.updateSingleTrip(this.selectedTrip);
    }


    updateSingleTrip(payload) {
      this.assignTripService
        .updateTrip(payload)
        .pipe(takeUntil(componentDestroyed(this)))
        .subscribe(data => {
          if (data) {
            this.selectedTrip = null;
            data.driver = this.preDriverList[data.driver];
            this.updatedTrip.emit(data);

          }
        }, err => {
          sweetAlert('Error', err, 'warning', 'OK');
        });
    }

  reorderKeys(obj) {
    const ordered:any = {};

    if ('will_call' in obj) ordered.will_call = obj.will_call;
    if ('no_driver' in obj) ordered.no_driver = obj.no_driver;

    for (const key in obj) {
      if (key !== 'will_call' && key !== 'no_driver') {
        ordered[key] = obj[key];
      }
    }

    return ordered;
  }


  ngOnDestroy(): void {
  }

}
